import { FontReference, NamedColor } from '@celum/shared/domain';

export type DesignThemeColorPaletteConfiguration = {
  primaryColor: NamedColor;
  contrastColor: NamedColor;
  customColors: NamedColor[];
  // highest index of custom colors that has ever been used -> this helps to generate new unique custom color ids
  highestCustomColorIdAlreadyUsed: number;
  grayScaleColors: NamedColor[];
};

export enum FontFormat {
  UPPERCASE = 'uppercase',
  UNDERLINE = 'underline',
  ITALIC = 'italic'
}

export type TypographyKey = 'heading-1' | 'heading-2' | 'heading-3' | 'body' | 'quote';
export interface TypographySetting {
  font: FontReference;
  fontWeight: number;
  fontSize: number;
  lineHeight: number;
  fontColorId: string;
  formatting: FontFormat[];
  key: TypographyKey;
}

export type DesignThemeConfiguration = {
  colorPalette: DesignThemeColorPaletteConfiguration;
  typography: Typography;
};

export type Typography = {
  settings: TypographySetting[];
  mainFont: FontReference;
};
